export var MuiPaper = {
    elevation: 0,
    square: true,
};
//# sourceMappingURL=MuiPaper.js.map